import { LOGIN_MUTATION } from '../constants/graphql/authentication';
import * as Sentry from '@sentry/browser';

const loginService = {
  login(uniqueIdentifier, password, apollo, store) {
    store.dispatch('setHasSeenPopupSinceLogin', undefined);
    store.dispatch('setHasSeenTebaEmailPopupSinceLogin', undefined);

    return apollo
      .mutate({
        mutation: LOGIN_MUTATION,
        variables: {
          uniqueIdentifier,
          password,
        },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        return error;
      });
  },
  setSentryUser(userId) {
    Sentry.setUser({ id: userId });
  },
  redirectToNext(router, store = null) {
    if (store?.getters?.pendingRedirect) {
      const redirectPath = store.getters.pendingRedirect;
      store.dispatch('setPendingRedirect', null);
      router.push(redirectPath);
    } else if (router.currentRoute.query.redirect) {
      router.push(router.currentRoute.query.redirect);
    } else if (store?.getters?.isAdminOrAdvisor) {
      router.push('/admin');
    } else if (store?.getters?.isLeadProvider) {
      router.push('/lead-provider');
    } else {
      router.push('/overview');
    }
  },
};

export default loginService;
